import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AddPolicyComposer } from "@/forms/rema/addPolicy/composer"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { FileKey } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

function AddPolicyPage() {
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0">
        <CardHeader className="border-b bg-slate-700 text-white [&_p]:text-slate-300">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <FileKey className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Add Policy</CardTitle>
              <CardDescription className="text-base">Define a new RBAC access policy</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <AddPolicyComposer
            showHeader={false}
            onSuccess={() => navigate({ to: '/rema/policies' })}
            onError={(error) => toast({ title: 'Error', description: `Failed to create policy: ${error.message}`, type: 'error' })}
            onCancel={() => navigate({ to: '/rema/policies' })}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/rema/policies/add")({
  staticData: {
    title: 'Add Policy',
    isSecured: true,
  },
  component: AddPolicyPage,
})
